<template>
  <div>
    <!-- <el-row>
      <h2>自录客户结算</h2>
    </el-row> -->
    <!-- <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="small">
          <el-form-item label="客户：">
            <el-select filterable v-model="searchForm.customerName" placeholder="请选择" :clearable="true">
              <el-option v-for="item in customer" :key="item.TC_ID" :label="item.NAME" :value="item.TC_ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="月份：">
            <el-date-picker v-model="searchForm.MONTH" type="month" :clearable="true" placeholder="选择日期"
              format="yyyy 年 MM 月" value-format="yyyy-MM">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button @click="doQueryTable()" :loading="loading">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="exportData">日结算数据导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <span>总收入：{{ totalFee }}元</span>
      </el-col>
      <el-col :span="4">
        <span>总成本：{{ totalCost }}元</span>
      </el-col>
      <el-col :span="4">
        <span>总利润：{{ realMoney }}元</span>
      </el-col>
    </el-row> -->
    <el-row>
      <el-col>
        <el-table border stripe :data="tableData" show-summary style="margin-top: 20px">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column label="客户名称" prop="TC_NAME"></el-table-column>
          <el-table-column label="月份" prop="MONTH"></el-table-column>
          <el-table-column prop="TOTAL_SUPPLIER_FEE" label="收入（元）" min-width="100"></el-table-column>
          <el-table-column prop="TOTAL_COST" label="成本（元）" min-width="100"></el-table-column>
          <el-table-column prop="PROFIT" label="利润（元）" min-width="100"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="small" icon="el-icon-view" @click="detail(scope.row)" type="text">查看</el-button>
              <el-button size="small" icon="el-icon-view" @click="detailThis(scope.row)" type="text">结算统计</el-button>
              <el-button size="small" icon="el-icon-view" @click="invoiceDetail(scope.row)" type="text">开票明细</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount">
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { customerOrderFun, newCustomerName } from 'api/tcBanlance';
import http from '@/assets/common/http';

export default {
  props: {
    searchForm2: {
      type: Object,
      default: null,
    },
    currentPage2: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      tableData: [],
      searchForm: this.searchForm2,
      customer: [],
      currentPage: this.currentPage2,
      totalCount: 0,
      pageSize: 10,
      totalCost: 0,
      totalFee: 0,
      loading: false,
      realMoney: 0,
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    // if (this.NEW_ORDER_SEARCH_DATA_CONDITION.CONDITION) {
    //   this.searchForm = this.NEW_ORDER_SEARCH_DATA_CONDITION.CONDITION;
    // } else {
    //   this.currentPage = 1;
    // }
    // this.searchForm.MONTH = `${new Date().getFullYear()}-0${new Date().getMonth()}`;
    // this.queryData();
    // this.queryName();
  },
  computed: {
    // NEW_ORDER_SEARCH_DATA_CONDITION() {
    //   return this.$store.state.NEW_ORDER_SEARCH_DATA_CONDITION;
    // },
  },
  methods: {
    detailThis(row) {
      this.$router.push({ path: `/customerDetail/${row.TC_ID}/${row.MONTH}`, params: { id: row.TC_ID, month: row.MONTH } });
    },
    handleCurrentChange() {
      this.queryData();
    },
    // ----------------------------------------------查看详情
    detail(row) {
      this.$router.push({ path: '/customerOrderList/detail' });
      sessionStorage.setItem('tcID', row.TC_ID);
      sessionStorage.setItem('orderID', row.ORDER_ID);
      sessionStorage.setItem('MONTH', row.MONTH);
    },
    // -----------------------------------------------搜索
    doQueryTable() {
      this.currentPage = 1;
      this.queryData();
    },
    // ------------------------------------------------拉取自录客户列表
    async queryData() {
      const params = {
        PAGEINDEX: this.currentPage - 1,
        PAGESIZE: this.pageSize,
      };
      if (this.searchForm.customerName) {
        params.TC_ID = this.searchForm.customerName;
      }
      if (this.searchForm.MONTH) {
        params.MONTH = this.searchForm.MONTH;
      }
      this.loading = true;
      await customerOrderFun(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result[0].list;
          this.totalCount = result[0].TOTAL_COUNT;
          this.$store.dispatch('SET_NEW_ORDER_SEARCH_DATA_CONDITION', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
          this.tableData.forEach((item, index) => {
            item.PROFIT = Math.round((Number(item.TOTAL_SUPPLIER_FEE) - Number(item.TOTAL_COST)) * 100) / 100;
          });
          this.totalCost = result[0].TOTAL_COST;
          this.totalFee = result[0].TOTAL_FEE;
          this.realMoney = Math.round((Number(result[0].TOTAL_FEE) - Number(result[0].TOTAL_COST)) * 100) / 100;
        } else {
          this.tableData = [];
          this.$message.show({ text: '暂无数据', type: 'success' });
          this.totalCost = 0;
          this.totalFee = 0;
          this.realMoney = 0;
        }
        this.$emit('dataChange', { totalCost: this.totalCost, totalFee: this.totalFee, realMoney: this.realMoney });
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ---------------------------------------------获取客户名称
    async queryName() {
      const params = {};
      await newCustomerName(params)
        .then((result) => {
          if (result.length !== 0) {
            this.customer = result[1].list;
          } else {
            this.customer = [];
          }
          this.$emit('customerChange', this.customer);
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 开票明细
    invoiceDetail(row) {
      this.$router.push({ name: 'tcInvoiceDetail', params: { isgys: '1' } });
      sessionStorage.setItem('TC_ID', row.TC_ID);
      sessionStorage.setItem('MONTH', row.MONTH);
    },
    // 日结算数据导出
    exportData() {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 55,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.customerName) {
        params.TC_ID = this.searchForm.customerName;
      }
      if (this.searchForm.MONTH) {
        params.MONTH = this.searchForm.MONTH;
      }
      http.post(params)
        .then((result) => {
          if (result.length !== 0) {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
          } else {
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/financeCenter/customerBalance.vue